import moment from "moment";

export const dateIsBeforeToday = (day) => moment(day).isBefore(moment());
